import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { getReportBySlug, getReportsMenuItems, IReports } from "./reportsApi";
import { useLocalStorageCache } from "./utils/useLocalStorageCache";

const cacheDuration = 20 * 60 * 60 * 1000; // 20 hours in milliseconds

export function useReportsMenuItems() {
  return useLocalStorageCache<IReports[]>({
    queryKey: "reports-menu-items-3", // increment to avoid getting old data
    queryFn: getReportsMenuItems,
    cacheDuration,
  });
}

export function useReport(slug: string, options?: UseQueryOptions<IReports>) {
  return useQuery({
    ...options,
    queryKey: ["report-by-slug", slug],
    queryFn: () => getReportBySlug(slug),
  });
}
